import React from 'react';
import { offerDocumentHtmlBase64 } from './offerDocumentHtml';

const offerDocumentHtml = new TextDecoder().decode(
  Uint8Array.from(atob(offerDocumentHtmlBase64), char => char.charCodeAt(0)),
);

export default function OfferPage() {
  return (
    <section className="offer-page">
      <div className="offer-page-head">
        <div>
          <p className="section-kicker">Bitbanker KG</p>
          <h1>Публичная оферта</h1>
        </div>
        <a className="offer-download" href="/bitbanker-offer.docx" download>
          Скачать DOCX
        </a>
      </div>
      <iframe
        className="offer-frame"
        srcDoc={offerDocumentHtml}
        title="Публичная оферта Bitbanker KG"
      />
    </section>
  );
}
